<template>
  <!-- 国内申请改签 -->
  <div style="width:100%">
    <div class="content-info">
      <h4 class="fs15">订单信息</h4>
      <div class="content-info_text fs12">
        <span>订单号：{{detailData.orderNo||defaultText}}</span>
        <span>订单状态；{{detailData.orderStatusText||defaultText}}</span>
        <span>PNR；{{detailData.pnr||defaultText}}</span>
        <span>预定时间：{{detailData.orderTime||defaultText}}</span>
        <span>出票时间：{{detailData.ticketTime||defaultText}}</span>
        <span>订单总价：￥{{detailData.amount||defaultText}}</span>
        <span>支付方式：{{detailData.payTypeText||defaultText}}</span>
        <span>交易时间：{{detailData.payTime||defaultText}}</span>
      </div>
    </div>
    <child-ticket
      v-if="$route.query.psgType==2"
      :detailData="detailData"
      :getChildAirInfo="getChildAirInfo"
    ></child-ticket>
    <div class="content-list" v-else>
      <h2>乘客/航程信息</h2>
      <div v-for="(air,index) in detailData.passengerList" :key="index">
        <div class="passenger-list fs13">
          <span>乘客姓名：{{air.psgName}}</span>
          <span>乘客类型：{{air.psgTypeText}}</span>
          <span>证件类型：{{air.cardTypeText}}</span>
          <span>证件号码：{{air.cardNo}}</span>
        </div>
        <el-table
          ref="multipleTable"
          :data="air.changeSegmentList"
          tooltip-effect="dark"
          style="width: 100%"
          :class="{'showCheckBox':$route.query.psgType==3}"
          @selection-change="(val)=>selectFlight(val,index,air)"
        >
          <el-table-column type="selection" width="55" :selectable="checkSelectable"></el-table-column>
          <el-table-column label="航段" width="80" prop="segmentTypeText" align="center"></el-table-column>
          <el-table-column label="航空公司" align="center">
            <template slot-scope="scope">{{ scope.row.airlineName }}</template>
          </el-table-column>
          <el-table-column label="航班号" align="center">
            <template slot-scope="scope">{{ scope.row.flightNo }}</template>
          </el-table-column>
          <el-table-column label="舱位" align="center">
            <template slot-scope="scope">{{ scope.row.cabinCode }}</template>
          </el-table-column>
          <el-table-column label="起抵地" align="center">
            <template slot-scope="scope">
              <p>
                {{scope.row.sCityName + scope.row.sAirportCode}} -
                {{scope.row.eCityName + scope.row.eAirportCode}}
              </p>
            </template>
          </el-table-column>
          <el-table-column label="起飞时间" align="center" width="100px">
            <template slot-scope="scope">
              {{ scope.row.beginDate}}
              {{scope.row.beginTime}}
            </template>
          </el-table-column>
          <el-table-column label="到达时间" align="center" width="100px">
            <template slot-scope="scope">
              {{ scope.row.arriveDate}}
              {{scope.row.arriveTime}}
            </template>
          </el-table-column>
          <el-table-column label="票号" align="center" prop="ticketNumber"></el-table-column>
          <el-table-column label="成人票号" align="center" width="100px" v-if="$route.query.psgType==3">
            <template slot-scope="scope">
              <el-input v-model="scope.row.aduTicketNumber" size="mini"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- <div class="content-list">
      <h2>已改签航班信息</h2>
      <div>
        <el-table ref="multipleTable" :data="detailData.invalidSegmentList"
        @selection-change="(val)=>selectFlight(val,'invalid')" tooltip-effect="dark" style="width: 100%">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="航段" width="80" align="center" prop="segmentTypeText"></el-table-column>
          <el-table-column label="航空公司" align="center">
            <template slot-scope="scope">{{ scope.row.airlineName }}</template>
          </el-table-column>
          <el-table-column label="航班号" align="center">
            <template slot-scope="scope">{{ scope.row.flightNo }}</template>
          </el-table-column>
          <el-table-column label="舱位" align="center">
            <template slot-scope="scope">{{ scope.row.cabinCode }}</template>
          </el-table-column>
          <el-table-column label="起抵地" align="center">
            <template slot-scope="scope">
              <p>{{scope.row.sCityName + scope.row.sAirportCode}} -
                 {{scope.row.eCityName + scope.row.eAirportCode}}
                  </p>
            </template>
          </el-table-column>
          <el-table-column label="起飞时间" align="center">
            <template slot-scope="scope">
              {{ scope.row.beginDate}}
              {{scope.row.beginTime}}
            </template>
          </el-table-column>
          <el-table-column label="到达时间" align="center">
            <template slot-scope="scope">
              {{ scope.row.arriveDate}}
              {{scope.row.arriveTime}}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>-->
    <div class="content-list">
      <h2>申请内容</h2>
      <div class="changing_box fs14">
        <div class="mt10" v-if="$route.query.psgType!=3">
          <span>改签类型：</span>
          <el-select v-model="formData.chaReason" placeholder="请选择" size="mini">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="mt10 mb20" v-if="$route.query.psgType!=3">
          <span>变更类型：</span>
          <el-radio-group v-model="formData.changeType" @change="selectType">
            <el-radio :label="1">改期</el-radio>
            <el-radio :label="2">升舱</el-radio>
          </el-radio-group>
        </div>
        <div
          class="flex-center-start mb20"
          style="align-items: stretch;"
          v-if="formData.chaReason==2"
        >
          <span>延误/病退证明：</span>
          <el-upload
            class="upload-demo"
            action=""
            :http-request="uploadImg"
            :on-remove="removeImg"
            :before-upload="detectionImg"
            multiple
            :limit="3"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">（支持jpg、png、bmp格式，文件小于500k，最多上传3张凭证）</div>
          </el-upload>
        </div>
        <div class="changing_msg mb20">
          <span style="width:80px">备注：</span>
          <el-input type="textarea" :rows="4" placeholder="" v-model="formData.remark"></el-input>
        </div>
      </div>
    </div>
    <div class="content-list" v-if="$route.query.psgType==1">
      <h2>改签航班信息</h2>
      <div>
        <el-table ref="multipleTable" :data="changeSegment" style="width: 100%">
          <el-table-column label="航段" width="80" align="center" prop="segmentTypeText"></el-table-column>
          <el-table-column label="航空公司" align="center">
            <template slot-scope="scope">{{ scope.row.airlineName }}</template>
          </el-table-column>
          <el-table-column label="航班号" align="center" width="100">
            <template slot-scope="scope">
              <el-input v-model="scope.row.flightNo" size="mini" :disabled="disabledTime==2"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="舱位" align="center" width="90">
            <template slot-scope="scope">
              <el-input v-model="scope.row.cabinCode" size="mini"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="起抵地" align="center">
            <template slot-scope="scope">
              <p>
                {{scope.row.sCityName + scope.row.sAirportCode}} -
                {{scope.row.eCityName + scope.row.eAirportCode}}
              </p>
            </template>
          </el-table-column>
          <el-table-column label="起飞时间" align="center">
            <template slot-scope="scope">
              <el-date-picker
                size="mini"
                :disabled="disabledTime==2"
                v-model="scope.row.startTime"
                :picker-options="pickerOptions"
                type="datetime"
                format="yyyy-MM-dd HH:mm"
                placeholder="选择日期时间"
              ></el-date-picker>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- <div class="content-list">
      <h2>改签乘客</h2>
      <div>
        <el-table ref="multipleTable" :data="detailData.passengerList"
          @selection-change="selectPassenger" tooltip-effect="dark" style="width: 100%">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="乘客姓名" width="80" align="center" prop="psgName"></el-table-column>
          <el-table-column label="乘客类型" align="center">
            <template slot-scope="scope">{{ scope.row.psgTypeText }}</template>
          </el-table-column>
          <el-table-column label="证件类型" align="center">
            <template slot-scope="scope">{{ scope.row.cardTypeText }}</template>
          </el-table-column>
          <el-table-column label="证件号码" align="center">
            <template slot-scope="scope">{{ scope.row.cardNo }}</template>
          </el-table-column>
          <el-table-column label="手机号码" align="center">
            <template slot-scope="scope">{{ scope.row.mobile }}</template>
          </el-table-column>
          <el-table-column label="原票号" align="center">
            <template slot-scope="scope">{{ scope.row.ticketNumber }}</template>
          </el-table-column>
        </el-table>
      </div>
    </div>-->
    <div class="content-list">
      <h2>改签说明</h2>
      <div class="mb20 fs14" style="padding:10px 25px;">
        <p class="mt10 mb10">1、平台退改工作时间:8：30 ~ 22：00（周一至周日）请您提交改签时尽量在工作时段内提交，避免产生损失；</p>
        <p class="mt10 mb10">2、改签相关费用提交申请后，由专属客服与您联系确认。</p>
      </div>
    </div>
  </div>
</template>
<script>
import upLoadImg from "@/lib/data-service/default/web_common_upload_aptitudeSingleImage";
import ChangClause from "./changClause";
import rule from "@/lib/data-service/flight/newFligthApi/buyer_dom_white_rule";
import ChildTicket from "./childTicket";
import index from "../admin/change-order-list";
export default {
  name: "ChangRefund",
  data() {
    return {
      tableData: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 1000 * 3600 * 24;
        }
      },
      defaultText: "-----",
      ruleText: "",
      options: [
        {
          value: 1,
          label: "自愿改签"
        },
        {
          value: 2,
          label: "非自愿改签"
        }
      ],
      radio: "",
      textarea: "",
      formData: {
        changeType: 1,
        orderNo: this.detailData.orderNo,
        passengerNoList: [],
        remark: "",
        segmentList: [],
        chaReason: 1
      },
      segmentList: [],
      changeSegment: [],
      disabledTime: null,
      flight: {},
      fileImg: []
    };
  },
  components: {
    ChangClause,
    ChildTicket
  },
  props: ["detailData"],
  watch: {
    formData: {
      deep: true,
      handler: function(newV, oldV) {
        this.$emit("getData", newV);
      }
    }
  },
  methods: {
    getAdultTiAcketNumber(val, flight, air) {
      // val = val.replace(/\s+/g, "");
      // if (val.length != 0) {
      //   let segmenList = {
      //     cabinCode: flight.cabinCode,
      //     depDate: flight.beginDate,
      //     depTime: flight.beginTime,
      //     flightNo: flight.flightNo,
      //     segmentNo: flight.segmentNo
      //   };
      //   if (this.formData.passengerNoList.length == 0) {
      //     this.formData.segmentList.push(segmenList);
      //     this.formData.passengerNoList.push(air.psgNo);
      //   } else {
      //     this.formData.passengerNoList.map((item, index) => {
      //       console.log(item, air.psgNo);
      //       if (item != air.psgNo) {
      //         this.formData.passengerNoList.push(air.psgNo);
      //         this.formData.segmentList.push(segmenList);
      //         this.formData.adultTicketNo.push(val);
      //       }
      //     });
      //   }
      // } else {
      //   this.formData.passengerNoList.map((item, index) => {
      //     if (item === air.psgNo) {
      //       this.formData.passengerNoList.splice(index, 1);
      //     }
      //   });
      //   this.formData.segmentList.map((item, index) => {
      //     item.segmentNo === flight.segmentNo
      //       ? this.formData.segmentList.splice(index, 1)
      //       : "";
      //   });
      // }
      // console.log(this.formData);
    },
    checkSelectable(val) {
      return true;
      // if (this.$route.query.psgType == 1) {
      //   return true;
      // } else {
      //   return false;
      // }
    },
    uploadImg(file) {
      upLoadImg(file.file).then(res => {
        this.fileImg.push({ url: res.fileList[0], uid: file.file.uid });
        this.getUrl(this.fileImg);
      });
    },
    getChildAirInfo(data) {
      let passengerNoList = this.formData.passengerNoList;

      let segmenList = {
        cabinCode: data.val.policys[0].cabin.chdCabinCode,
        depDate: data.val.depDate,
        depTime: data.val.depTime,
        flightNo: data.val.flightNo,
        segmentNo: data.changAir.segmentNo,
        arrDate: data.val.arrDate,
        arrTime: data.val.arrTime
      };
      if (this.formData.passengerNoList.length == 0) {
        passengerNoList.push(data.air.psgNo);
      } else {
        if (!data.btnShow) {
          passengerNoList.push(data.air.psgNo);
        } else {
          this.formData.passengerNoList.map((item, index) => {
            if (item == data.air.psgNo) {
              this.formData.passengerNoList.splice(index, 1);
            }
          });
          this.formData.segmentList.map((segment, index) => {
            if (segment.segmentNo == data.changAir.segmentNo) {
              this.formData.segmentList.splice(index, 1);
            }
          });
          console.log(this.formData);
          return;
        }
      }

      this.formData.segmentList.push(segmenList);
      console.log(this.formData);
    },
    backRule(val) {
      console.log(val);
      this.ruleText = "";
      let data = {
        arrCityPortCode: val.arrAirportCode,
        cabinCode:
          this.psgType == 2
            ? val.policys[0].cabin.chdCabinCode
            : val.policys[0].cabin.cabinCode,
        depCityPortCode: val.depAirportCode,
        depDate: val.depDate,
        flightNo: val.flightNo,
        flightType: this.airType,
        psgType: this.psgType,
        supplierType: val.supplierType,
        policyId: val.policys[0].policyId,
        extData: val.policys[0].extData,
      };
      rule(data).then(res => {
        // let refRule = res.refRule.rules;
        // let chaRule = res.chaRule.rules;
        // refRule.map(item => (item.type = "refRule"));
        // chaRule.map(item => (item.type = "chaRule"));
        // this.ruleText = [refRule, chaRule];
        this.ruleText = res.chaRule.content;
      });
    },
    getUrl(val) {
      let url = val.map(item => {
        return item.url;
      });
      this.formData.url = url.join(",");
    },
    detectionImg(file) {
      var reg2 = /^(\s|\S)+(jpg|png|bmp)+$/;
      const isLt2M = file.size / 1024 < 500;
      if (!reg2.test(file.name)) {
        this.$message({ type: "warning", message: "图片格式上传错误！" });
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 500K!");
        return false;
      }
    },
    removeImg(file) {
      this.fileImg.map((item, index) => {
        item.uid == file.uid ? this.fileImg.splice(index, 1) : "";
      });
      this.getUrl(this.fileImg);
    },
    selectType(val) {
      this.disabledTime = val;
      this.$forceUpdate();
    },

    selectFlight(val, name, flight) {
      this.segmentList[name] = val;
      let list = [].concat(...this.segmentList);
      list = list.filter(item => item);
      console.log(list);
      let arr = [];
      /**去重 */
      var setFlight = list => {
        for (let i = 0; i < list.length - 1; i++) {
          if (list.length > 1) {
            for (let j = 1; j < list.length; j++) {
              if (list[j].segmentType === list[i].segmentType) {
                list.splice(j, 1);
              }
            }
          }
        }
      };

      this.changeSegment = JSON.parse(JSON.stringify(list));
      setFlight(this.changeSegment);
      this.formData.segmentList = this.changeSegment;
      // if (this.$route.query.psgType == 3) {
      //   this.formData.segmentList = arr;
      // } else {
      //   this.formData.segmentList = this.changeSegment;
      // }
      this.selectPassenger(val, name, flight);
    },
    selectPassenger(val, name, flight) {
      val.length > 0 ? (this.flight[name] = flight) : (this.flight[name] = []);
      let list = Object.values(this.flight);
      let psgNo = list.map(item => {
        return item.psgNo;
      });
      this.formData.passengerNoList = psgNo;
    }
  }
};
</script>
<style lang="less" scoped>
@import "~@/lib/deprecated/styles/common.less";

.content-list {
  @contentBox();
  .el-table {
    font-size: 13px;
  }
}
.content_table {
  @contentTable();
}
.changing_box {
  padding: 10px 25px;
  color: @ftText;
  .changing_msg {
    display: flex;
    align-items: stretch;
  }
  /deep/.el-input {
    input {
      border-radius: 0;
    }
  }
  /deep/.el-textarea {
    .el-textarea__inner {
      border-radius: 0;
    }
  }
}
.el-button {
  border-radius: 0;
}
.content-info {
  border: 1px solid #ffb27f;
  h4 {
    background: #fff5ef;
    padding: 8px 25px;
    font-weight: 400;
  }
  &_text {
    display: flex;
    flex-flow: wrap;
    background: #fffcfa;
    padding: 15px 25px;
    span {
      width: 25%;
      display: block;
      padding: 6px 0;
    }
  }
}
.passenger-list {
  padding: 10px 25px;
  background: #ecf6ff6e;
  border-bottom: 1px dashed #dfdfdf;
  span {
    padding-right: 40px;
  }
}
.fs13 {
  p {
    padding: 5px 0;
  }
}
// /deep/.showCheckBox {
//   .el-checkbox {
//     display: none;
//   }
// }
</style>
